let algoliaInitialized = false;

function initAlgolia() {
  if (algoliaInitialized) return;
  if (!window.algoliasearch || !window['@algolia/autocomplete-js']) {
    setTimeout(initAlgolia, 100);
    return;
  }

  const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
  const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions'];
  const { createLocalStorageRecentSearchesPlugin, search } = window['@algolia/autocomplete-plugin-recent-searches'];
  const searchClient = window.algoliasearch.algoliasearch('T1NBH0U8TM', '8d8706f8e1892afda34174e16b43eeef');

  // Helper function to get translations
  const getTranslation = (key) => {
    const isEnglish = window.location.pathname.includes('/en/');
    const translations = {
      en: {
        products: 'PRODUCTS',
        show_all_products: 'SHOW ALL PRODUCTS',
        recent_searches: 'RECENT SEARCHES',
        suggestions: 'SUGGESTIONS',
        placeholder: 'Search',
        no_results: 'No results found',
        variants: 'VARIANTS',
      },
      de: {
        products: 'PRODUKTE',
        show_all_products: 'ALLE PRODUKTE ANZEIGEN',
        recent_searches: 'ZULETZT GESUCHT',
        suggestions: 'VORSCHLÄGE',
        placeholder: 'Suchen',
        no_results: 'Keine Ergebnisse gefunden',
        variants: 'Varianten',
      },
    };

    return isEnglish ? translations.en[key] : translations.de[key];
  };

  const querySuggestionsPlugin = createQuerySuggestionsPlugin({
    searchClient,
    indexName: 'shopify_products_query_suggestions',
    getSearchParams() {
      return {
        hitsPerPage: 4,
      };
    },
    transformSource({ source }) {
      return {
        ...source,
        onSelect({ setIsOpen }) {
          setIsOpen(true);
        },
        templates: {
          ...source.templates,
          header({ html }) {
            return html`
              <div class="aa-SourceHeader peak-header">
                <span class="aa-SourceHeaderTitle">${getTranslation('suggestions')}</span>
              </div>
            `;
          },
        },
      };
    },
  });

  const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
    key: 'autocomplete-two-column-layout-example',
    search(params) {
      return search({ ...params, limit: params.query ? 1 : 4 });
    },
    transformSource({ source }) {
      return {
        ...source,
        onSelect({ setIsOpen }) {
          setIsOpen(true);
        },
        templates: {
          ...source.templates,
          header({ html }) {
            return html`
              <div class="aa-SourceHeader peak-header">
                <span class="aa-SourceHeaderTitle">${getTranslation('recent_searches')}</span>
              </div>
            `;
          },
        },
      };
    },
  });

  const productsPlugin = {
    getSources({ query }) {
      if (!query || query.length < 3) {
        return [];
      }

      return [
        {
          sourceId: 'productsPlugin',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_products',
                  query,
                  params: {
                    hitsPerPage: 4,
                    distinct: true, // Enable deduplication
                  },
                },
              ],
            });
          },
          templates: {
            header({ html, state }) {
              if (!state.query) return null;
              return html`
                <div class="aa-SourceHeader peak-header">
                  <div class="aa-SourceHeaderRow">
                    <span class="aa-SourceHeaderTitle">${getTranslation('products')}</span>
                    <a href="/search?q=${state.query}" class="aa-HeaderViewAllButton">
                      <span>${getTranslation('show_all_products')}</span>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              `;
            },
            item({ item, html }) {
              if (!item) return null;

              const price = typeof item.price === 'number' ? item.price.toFixed(2) : item.price;
              const compareAtPrice = item.compare_at_price || null;
              const discountPercentage =
                compareAtPrice && compareAtPrice > item.price
                  ? Math.round((100 * (compareAtPrice - item.price)) / compareAtPrice)
                  : null;

              const variantTitle = item.variant_title ? item.variant_title : '';

              return html`
                <a href="/products/${item.handle}" class="link_search_item">
                  ${item.image ? html`<img src="${item.image}" alt="${item.title}" loading="lazy" />` : ''}
                  <span class="product-title">${item.title}</span>
                  ${variantTitle && variantTitle !== 'Default Title'
                    ? html`<span class="product-variant-title"
                        >${variantTitle}
                        ${item.variants_count > 1
                          ? ` + ${item.variants_count} ${getTranslation('variants')}`
                          : ''}</span
                      >`
                    : ''}
                  ${compareAtPrice ? html`<span class="product__compare-at-price">${compareAtPrice}€</span>` : ''}

                  <div class="product-price__row">
                    <span class="product-price">${price}€</span>
                    ${discountPercentage
                      ? html`<span class="product-discount-percentage">-${discountPercentage}%</span>`
                      : ''}
                  </div>
                </a>
              `;
            },
          },
        },
      ];
    },
  };

  // Initialize autocomplete
  const initializeAutocomplete = () => {
    autocomplete({
      container: '#autocomplete',
      placeholder: getTranslation('placeholder'),
      openOnFocus: true,
      plugins: [querySuggestionsPlugin, recentSearchesPlugin, productsPlugin],
      onSubmit({ state }) {
        if (state.query) {
          window.location.href = `/search?q=${encodeURIComponent(state.query)}`;
        }
      },
      render({ elements, render, html, state }, root) {
        const { productsPlugin, recentSearchesPlugin, querySuggestionsPlugin } = elements;

        if (!state.query) {
          return render(
            html`
              <div class="aa-PanelLayout">
                <div class="aa-PanelSections">
                  <div class="aa-PanelSection--left">${recentSearchesPlugin}</div>
                </div>
              </div>
            `,
            root
          );
        }

        return render(
          html`
            <div class="aa-PanelLayout">
              <div class="aa-PanelSections">
                <div class="aa-PanelSection--left">
                  <div class="aa-PanelSectionSources">${recentSearchesPlugin} ${querySuggestionsPlugin}</div>
                </div>
                <div class="aa-PanelSection--right">
                  <div class="aa-PanelSection--products">
                    <div class="product-search-grid">${productsPlugin}</div>
                  </div>
                </div>
              </div>
            </div>
          `,
          root
        );
      },
    });
  };

  // Initialize autocomplete
  initializeAutocomplete();

  // Handle mobile search icon click
  const searchIcon = document.querySelector('.search_icon');
  const searchWrapper = document.querySelector('.search_wrapper');
  const darkOverlay = document.querySelector('.dark_overlay');
  const closeSearchBar = document.querySelector('.close_search_bar');

  if (searchIcon) {
    searchIcon.addEventListener('click', () => {
      if (searchWrapper) {
        searchWrapper.classList.add('active');
        document.body.style.overflowY = 'hidden';

        // Focus the search input after a short delay to ensure the animation is complete
        setTimeout(() => {
          const searchInput = document.querySelector('.aa-Input');
          if (searchInput) {
            searchInput.focus();
          }
        }, 300);
      }
    });
  }

  if (darkOverlay) {
    darkOverlay.addEventListener('click', () => {
      if (searchWrapper) {
        searchWrapper.classList.remove('active');
        document.body.style.overflowY = 'auto';
      }
    });
  }

  if (closeSearchBar) {
    closeSearchBar.addEventListener('click', () => {
      if (searchWrapper) {
        searchWrapper.classList.remove('active');
        document.body.style.overflowY = 'auto';
      }
    });
  }

  algoliaInitialized = true;
}

// Start initialization
document.addEventListener('DOMContentLoaded', initAlgolia);
// Also try immediately in case DOM is already loaded
initAlgolia();
